<div class="min-h-screen flex flex-col items-center justify-center bg-gray-100">
	<div class="max-w-md text-center">
		<h1 class="text-9xl font-bold text-blue-600">404</h1>
		<h2 class="mt-4 text-3xl font-bold text-gray-800">
			{{'pageNotFound.title' | translate}}
		</h2>
		<p class="mt-2 text-gray-600">
			{{'pageNotFound.subtitle' | translate}}
		</p>
		<a [routerLink]="['/home']" routerLinkActive="router-link-active"
			class="mt-6 inline-block bg-blue-600 text-white py-2 px-4 shadow hover:bg-blue-700 focus:bg-blue-700 hover:text-white focus:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
			{{'pageNotFound.action' | translate}}
		</a>
	</div>
</div>